import { gql } from '@apollo/client';
import { PERSON_FRAGMENT, PERSON_WITH_RELATIONS_FRAGMENT, HOUSEHOLD_FRAGMENT } from './queries';

// Auth
export const LOGIN = gql`
  mutation Login($familyPassword: String!) {
    login(familyPassword: $familyPassword) {
      token
    }
  }
`;

// Person mutations
export const CREATE_PERSON = gql`
  ${PERSON_FRAGMENT}
  mutation CreatePerson($input: PersonInput!) {
    createPerson(input: $input) {
      ...PersonFields
    }
  }
`;

export const UPDATE_PERSON = gql`
  ${PERSON_WITH_RELATIONS_FRAGMENT}
  mutation UpdatePerson($id: ID!, $input: PersonInput!) {
    updatePerson(id: $id, input: $input) {
      ...PersonWithRelations
    }
  }
`;

export const DELETE_PERSON = gql`
  mutation DeletePerson($id: ID!) {
    deletePerson(id: $id)
  }
`;

// Relationship mutations
export const ADD_RELATIONSHIP = gql`
  mutation AddRelationship($fromPersonId: ID!, $toPersonId: ID!, $type: RelationshipType!) {
    addRelationship(fromPersonId: $fromPersonId, toPersonId: $toPersonId, type: $type) {
      id
      fromPersonId
      toPersonId
      type
    }
  }
`;

export const REMOVE_RELATIONSHIP = gql`
  mutation RemoveRelationship($id: ID!) {
    removeRelationship(id: $id)
  }
`;

// Message board mutations
export const CREATE_MESSAGE_BOARD_POST = gql`
  mutation CreateMessageBoardPost($authorName: String!, $authorPersonId: ID, $body: String!, $pinned: Boolean) {
    createMessageBoardPost(authorName: $authorName, authorPersonId: $authorPersonId, body: $body, pinned: $pinned) {
      id
      authorName
      authorPerson {
        id
        firstName
        lastName
      }
      body
      createdAt
      pinned
    }
  }
`;

export const UPDATE_MESSAGE_BOARD_POST = gql`
  mutation UpdateMessageBoardPost($id: ID!, $body: String, $pinned: Boolean) {
    updateMessageBoardPost(id: $id, body: $body, pinned: $pinned) {
      id
      authorName
      body
      createdAt
      pinned
    }
  }
`;

export const DELETE_MESSAGE_BOARD_POST = gql`
  mutation DeleteMessageBoardPost($id: ID!) {
    deleteMessageBoardPost(id: $id)
  }
`;

// Invite mutations
export const CREATE_INVITE = gql`
  mutation CreateInvite($personId: ID!, $email: String!) {
    createInvite(personId: $personId, email: $email) {
      id
      personId
      email
      token
      expiresAt
    }
  }
`;

export const REDEEM_INVITE = gql`
  ${PERSON_FRAGMENT}
  mutation RedeemInvite($token: String!) {
    redeemInvite(token: $token) {
      ...PersonFields
    }
  }
`;

// Household mutations
export const CREATE_HOUSEHOLD = gql`
  ${HOUSEHOLD_FRAGMENT}
  mutation CreateHousehold($input: HouseholdInput!) {
    createHousehold(input: $input) {
      ...HouseholdFields
    }
  }
`;

export const UPDATE_HOUSEHOLD = gql`
  ${HOUSEHOLD_FRAGMENT}
  mutation UpdateHousehold($id: ID!, $input: HouseholdInput!) {
    updateHousehold(id: $id, input: $input) {
      ...HouseholdFields
    }
  }
`;

export const DELETE_HOUSEHOLD = gql`
  mutation DeleteHousehold($id: ID!) {
    deleteHousehold(id: $id)
  }
`;
